// extracted by mini-css-extract-plugin
module.exports = {"navParent":"Navbar_navParent__ZdjgR","navbar":"Navbar_navbar__56epz","primaryBtn":"Navbar_primaryBtn__1CAOo","name":"Navbar_name__6Zo6o"};